import { createApp } from 'vue'
import App from './video.vue'

htmlReady(() => {
	let elements = document.querySelectorAll('.knd-video');

	for(var i = 0; i < elements.length; i++) {
		if(elements[i].dataset.id) {
			createApp(App, { ...elements[i].dataset }).mount(elements[i]);
		}
	}
})

// wait till everything is rendered 
function htmlReady(cb){
	// in case the document is already rendered
	if (document.readyState!='loading'){
		cb();
	}

	// modern browsers
	else if (document.addEventListener){ 
		document.addEventListener('DOMContentLoaded', cb);
	}
	// IE <= 8
	else document.attachEvent('onreadystatechange',() => {
		if (document.readyState=='complete') cb();
	});
}